<nav class="bg-white w-full">
  <div class="container mx-auto">
    <div class="py-4 flex justify-between items-center">
      <div>
        <a href="{{this.countryShort === 'nl' ? 'https://www.explect.nl' : 'https://www.explect.com'}}" target="_blank"
        ><img src="../../../assets/logo.svg" alt="The Explect logo." class="logo"  /></a>
      </div>
      <div class="flex items-center">
        <button class="btn btn-primary mr-2" (click)="this.navigationHandler('https://explect.isdigitized.com/')">Login to Explect Online</button>

        <img src="../../../assets/trust-pilot.png" alt="Trust pilot" class="trust-pilot" (click)="this.navigationHandler('https://www.trustpilot.com/review/www.explect.com')" />
      </div>
    </div>
  </div>
</nav>
